import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function initAnimation(): void {
  const images: NodeListOf<HTMLElement> = document.querySelectorAll('.image-hero:not(.image-hero-video)');

  images.forEach((img: HTMLElement) => {
    const rect: DOMRect = img.getBoundingClientRect();
    gsap.set(img, {
      x: window.innerWidth / 2 - rect.left - img.offsetWidth / 2,
      y: window.innerHeight / 2 - rect.top - img.offsetHeight / 2,
      scale: 0.2,
      opacity: 1,
      zIndex: -1,
    });
  });

  gsap.to(images, {
    x: 0,
    y: 0,
    scale: 1,
    duration: 1.2,
    ease: 'back.out(1.3)',
    stagger: 0.11,
    zIndex: -1,
  });

  const video = document.querySelector<HTMLElement>('.image-hero-video');
  const sectionVideo = document.querySelector<HTMLElement>('.section-video');

  if (video && sectionVideo) {
    const videoRect: DOMRect = video.getBoundingClientRect();
    gsap.set(video, {
      x: window.innerWidth / 2 - videoRect.left - video.offsetWidth / 2,
      y: window.innerHeight / 2 - videoRect.top - video.offsetHeight / 2,
      scale: 0.2,
      opacity: 1,
    });

    gsap.to(video, {
      x: 0,
      y: 0,
      scale: 1,
      opacity: 1,
      duration: 1.2,
      ease: 'back.out(1.3)',
      delay: 0.11 * images.length,
      onComplete: () => {
        const r = video.getBoundingClientRect();
        const startLeft   = r.left;
        const startTop    = r.top;
        const startWidth  = r.width;
        const startHeight = r.height;

        let done = false;

        gsap.set(video, {
          opacity: 1,
          position: 'fixed',
          left: startLeft,
          top: startTop,
          width: startWidth,
          height: startHeight,
          x: 0,
          y: 0,
          transform: 'none',
          zIndex: 2,
        });

        ScrollTrigger.create({
          trigger: sectionVideo,
          start: 'top bottom',
          end: 'top top',
          scrub: 1,
          onUpdate: (self) => {
            if (done) return;

            const p = self.progress;
            gsap.set(video, {
              left:   gsap.utils.interpolate(startLeft, 0, p),
              top:    gsap.utils.interpolate(startTop, 0, p),
              width:  gsap.utils.interpolate(startWidth, document.documentElement.clientWidth, p),
              height: gsap.utils.interpolate(startHeight, document.documentElement.clientHeight, p),
            });
          },
          onLeave: () => {
            done = true;
            gsap.set(video, { clearProps: 'all' });
            video.classList.remove('image-hero', 'image-hero-video');
            video.classList.add('video-fullscreen');
            sectionVideo.appendChild(video);
          },
        });
      },
    });
  }
}

window.addEventListener('agegate:ready', initAnimation, { once: true });